import { useEffect, useState } from "react";
import { setBookingForm } from "../../../ducks/actions";
import {
  createEmptyCommercialPlanField,
  getClearedCommercialPaymentPlanBookingFormPatch,
  PAYMENT_PLAN_TOR_TYPE_KEY,
  shouldResetPaymentPlansForTorTypeChange,
} from "./paymentPlanTorType";

type UseResetPaymentPlansOnTorTypeChangeOptions = {
  torType: string | undefined;
  isTurnoverRentOnly: boolean;
  paymentPlanTorType: string | undefined | null;
  bookingForm: Record<string, unknown>;
  dispatch: (action: unknown) => void;
  replace: (plans: unknown[]) => void;
  clearErrors: () => void;
};

export function useResetPaymentPlansOnTorTypeChange(options: UseResetPaymentPlansOnTorTypeChangeOptions) {
  const { torType, isTurnoverRentOnly, paymentPlanTorType, bookingForm, dispatch, replace, clearErrors } = options;

  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    if (!shouldResetPaymentPlansForTorTypeChange(paymentPlanTorType, torType)) return;

    clearErrors();
    replace(isTurnoverRentOnly ? [createEmptyCommercialPlanField(true)] : []);
    setResetKey((key) => key + 1);

    dispatch(
      setBookingForm({
        ...bookingForm,
        ...getClearedCommercialPaymentPlanBookingFormPatch(),
        [PAYMENT_PLAN_TOR_TYPE_KEY]: torType,
      }),
    );
  }, [torType, paymentPlanTorType, isTurnoverRentOnly, bookingForm, dispatch, replace, clearErrors]);

  return { resetKey };
}
